(function () {
    $ (function () {
        
        // форма на странице
        
        $ (".js-form-feedback-default").each (function () {
            const $form = $ (this);
            const $submit = $form.find (".js-i-form__submit");
            
            $form.on ("is:success", function () {
                const $success = $ (".js-form-feedback-default-success");
                
                $form.find (".b-input-text, .i-textarea").prop ("disabled", true);
                $form.find (".b-radio-btn__input").prop ("disabled", true);
                
                if ($submit.length > 0) {
                    $submit.remove ();
                }
                
                if ($success.length > 0) {
                    $success.removeClass ("_hidden");
                }
            });
            
            $form.on ("is:fail", function () {
                $ (document).trigger ('is:errorModal', {title: "Произошла ошибка!", text: ""});
            });
        });
    });
    
    
    $ (function () {
        
        // форма в модалке
        
        $ (".js-form-feedback-modal").each (function () {
            const $form = $ (this);
            const $submit = $form.find (".js-i-form__submit");
            
            $form.on ("is:success", function () {
                const $success = $ (".js-form-feedback-modal-success");
                
                $form.find (".b-input-text, .i-textarea").prop ("disabled", true);
                $form.find (".b-radio-btn__input").prop ("disabled", true);
                
                if ($submit.length > 0) {
                    $submit.remove ();
                }
                
                if ($success.length > 0) {
                    $success.removeClass ("_hidden");
                }
    
                // очищаем ошибку, если она есть
                
                const $fail = $ (".js-form-feedback-modal-notice");
    
                if ($fail.length > 0) {
                    $fail.text ("").removeClass ("_error");
                }
            });
            
            $form.on ("is:fail", function () {
                const $fail = $ (".js-form-feedback-modal-notice");
                
                if ($fail.length > 0) {
                    $fail.text ("Не удалось отправить форму").addClass ("_error");
                    
                    const $wrapper = $.fancybox.getInstance ().current.$content.find (".simplebar-content-wrapper");
                    const $content = $wrapper.find (".simplebar-content");
                    
                    $wrapper[0].scrollTo ({
                        top: $content.outerHeight (),
                        behavior: "smooth"
                    });
                }
            });
        });
    });

    $ (function () {
      
      $ (".js-form-feedback-partners-program").each (function () {
          const $form = $ (this);
          const $submit = $form.find (".js-i-form__submit");
          
          $form.on ("is:success", function () {
              const $success = $ (".js-form-feedback-partners-program-success");
              $form.find (".b-input-text, .i-textarea").prop ("disabled", true);
              $form.find (".b-radio-btn__input").prop ("disabled", true);
              
              if ($submit.length > 0) {
                  $submit.remove ();
              }
              
              if ($success.length > 0) {
                  $success.removeClass ("_hidden");
              }
          });
          
          $form.on ("is:fail", function () {
              $ (document).trigger ('is:errorModal', {title: "Произошла ошибка!", text: ""});
          });
      });
  });
} ());
